import React, { useEffect, useState } from "react";
import { academylist, hostelbulkupload, hostelloglist } from "../../../services/admin";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { toast } from "react-toastify";

export default function Hostelstudentsbulkuploafds() {
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [efile, setEFile] = useState("");
  const [filterProduct, setFilterProduct] = useState([]);

  const columnDefs = [
    {
      headerName: "Upload Excel",
      width: 170,
      field: "excel_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="excelfailed text-success"
              href={params.data.path + params.value}
              download={params.data.path + params.value}
              target="_blank"
            >
              Click to Download
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Failed Excel",
      width: 150,
      field: "mandatory_excel",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return (
            <div className="text-center">
              <a
                className="excelfailed text-danger"
                href={params.data.path + params.value}
                download={params.data.path + params.value}
                target="_blank"
              >
                Click to Download
              </a>
            </div>
          );
        }
      },
    },
    {
      headerName: "Uploaded on",
      width: 150,
      field: "created_at",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy hh:mm:ss A");
        }
      },
    },
    {
      headerName: "Uploaded by",
      width: 150,
      field: "user",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);
              }
            }
           
          }
        }
      });
    }else{
      listall("");
    }
  }, []);
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);

    } else {
      setAcaID("");
      listall("");

    }
  }

  function idcardfile(event) {
    setErrMsg("");
    setEFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(xlsx|xls)$/i)) {
        setEFile(event.target.files[0]);
      } else {
        setErrMsg("Upload excel should be xls or xlsx format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setErrMsg("Upload excel size should be less than 5MB");
      }
    }
  }
  const [errmsg, setErrMsg] = useState("");

  function hsubmit(e) {
    e.preventDefault();
    setErrMsg("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (efile !== "") {
        setLoading(true);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        temp.append("excel_name", efile);
        hostelbulkupload(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            setEFile("");
            setAcaID("");
            listall(acaid);
            toast.success(res.message);
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        })
      } else {
        setErrMsg("Please Upload Excel");
      }
    }
  }

  function listall(aid) {
    setFilterProduct([]);

    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("type", 1);

    hostelloglist(temp).then((response) => {
      if (response.status === true) {
        setFilterProduct(response.data.details);
      }
    });
  }

  const [loading, setLoading] = useState(false);
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Hostel Students Bulk Uploads</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Hostel Management</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Hostel Students Bulk Uploads
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading &&
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  Hostel Students Bulk Upload
                </h2>{" "}

              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="res-right">
                      <button className="btn btn-secondary" href={require("../../../assets/images/IDCard_BulkUpload.xlsx")} download>
                        Download Sample Excel
                      </button>
                    </div>
                  </div>
                  {localStorage.getItem("Role") === "1" &&
                   <div className="col-xl-6 col-sm-6">
                   <div className="mb-3">
                     <label className="form-label">
                       Select Academy<span className="text-danger"> *</span>
                     </label>
                     <Select
                       className="default-select"
                       placeholder="Select Academy"
                       value={acaid}
                       options={alist}
                       onChange={handleAcademy}
                       isSearchable={true}
                       isClearable
                       hidden
                     />
                   </div>
                 </div>
                  }
                 

                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Upload Excel<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="file"
                        className="form-control buttion-file"
                        accept=".xlsx, .xls"
                        onChange={idcardfile}
                      />
                    </div>
                  </div>

                  {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
                </div>
              </div>
              <div className="res-right mt-2 me-4">
                <button className="btn btn-success" onClick={hsubmit}>Submit</button>
              </div>
            </div>

            <div className="card custom-card mg-b-20">
              <div className="card-body">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Upload Preview
                  </h2>
                </div>
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>
            </div>


          </div>
        </div>
      }

    </div>
  );
}
